// var chains = '<div class="swatch-size custom-select-wrapper chain-selector d-none d-lg-block"><select class="custom-select"><option data-prodid="0" data-original-price="0" data-price="0">No Chain</option>';



(function ($) {

  'use strict';

  var store = 'aime-leon-dore';
  if(window.location.host.indexOf('eu') > -1) {
    store = 'aime-leon-dore-eu';
  }
  if(window.location.host.indexOf('dev') > -1) {
    store = 'aime-leon-dore-dev-store';
  }
  if(window.location.host.indexOf('eu-dev') > -1) {
    store = 'aime-leon-dore-eu-dev';
  }

  var aldscripts = {
    init: function () {
      // separate loads for product and cart page
      if(location.pathname.includes('/products/')) {
        aldscripts.recentlyViewed();  
      }
      // separate loads for product and cart page
      if(location.pathname.includes('/cart')) {
        console.log('>>>>>>>>>>', getOS(), window.navigator.userAgent, window.innerWidth)
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        console.log('>>>>>>>>>>', isSafari);
        // if(isSafari || getOS() == 'Mac OS') {
        if(window.innerWidth > 1024) {
          var height = window.innerHeight;
          var imgHeight = height - 340;
          var width = Math.floor((4 * imgHeight) / 5);
          console.log('>>>>>>>>>>>>>>', height, imgHeight, width);
          $('.upsell-carousel, .cart-upsell').width(width);
          if(width > 493) {
            $('.upsell-carousel img').width('100%');
          }
        }
        // }


        $(window).on('resize', function() {
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          console.log('>>>>>>>>>>', isSafari, 'wwi', window.innerWidth);
          // if(isSafari || getOS() == 'Mac OS') {
          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            console.log('>>>>>>>>>>>>>>', height, imgHeight, width);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }
          // }
        })

        aldscripts.loadUpsell();


        $('.cart-upsell-container').on('click', '.btn-upsell-add', function() {
          // console.log('add 1')
          if($(this).closest('.cart-upsell').find('.chain-select').length) {

            var variantId = $(this).closest('.cart-upsell').data('variantid');
            var qty = 1;

            var chainData = {
              quantity: 1,
              id: variantId,
              properties: {
                _recently_viewed_product: "true"
              }
            }



            // console.log('chaindata', chainData);

            // add pendant
            $.ajax({
              url: '/cart/add',
              type: 'POST',
              dataType: 'json',
              data: chainData,
              success: function(response) {

                if(chainId != 0) {

                  var attrs = ''; 
                  if(jewelryAtrributes != '') {
                    attrs = jewelryAtrributes + '//';
                  }

                  var chainData = {
                    quantity: 1,
                    id: chainId,
                    // note: $('#product-form-id').val() + '::' + chainId,
                    attributes: {
                      'jewelry': attrs + variantId + '::' + chainId
                    },
                    properties: {
                      _recently_viewed_product: "true"
                    }
                  }

                  $.ajax({
                    url: '/cart/add',
                    type: 'POST',
                    dataType: 'json',
                    data: chainData,
                    success: function(response) {
                      
                      jewelryAtrributes = attrs + variantId + '::' + chainId
                      window.location.reload()

                    },
                    error: function(data){
                      alert('No more units available.');
                    }
                  });

                } else {

                  var attrs = ''; 
                  if(jewelryAtrributes != '') {
                    attrs = jewelryAtrributes + '//';
                  }

                  // var variantId = $(this).closest('.cart-upsell').data('variantid');

                  // console.log('>> variantid', variantId);

                  $.ajax({
                    url: '/cart/update.js',
                    data: 'attributes[jewelry]=' + attrs + variantId + '::' + chainId,
                    method: 'POST',
                    async: false,
                    dataType: 'json',
                    cache: false,
                    success: function() {
                      jewelryAtrributes = attrs + variantId + '::' + chainId
                      window.location.reload()
                    }
                  });

                }

              }
            });

          } else {
            // var variantId = $(this).closest('.upsell-form').find('.swatch-size')[1].find('select').val();
            var variantId = $(this).closest('.upsell-form').find('.swatch-size4 select').val();;
            var qty = 1;

        var anySelectedVariant = '';

        // new template
        if($(this).closest('.upsell-form').find('.swatch-size select').length) {
          anySelectedVariant = $(this).closest('.upsell-form').find('.swatch-size select').val() == '' ? false : true;

          if(!anySelectedVariant) {
            $(this).closest('.upsell-form').find('.swatch-size').addClass('select-error');
          } else {
            $(this).closest('.upsell-form').find('.swatch-size').removeClass('select-error');
            var chainData = {
              quantity: 1,
              id: variantId,
              properties: {
                _recently_viewed_product: "true"
              }
            }

            $.ajax({
              url: '/cart/add',
              type: 'POST',
              dataType: 'json',
              data: chainData,
              success: function(response) {
                window.location.reload()
              }
            });
          }
        }


          }



          return false;
        });

            $('#notify_email').on('focus', function() {
      if($(window).width() < 1025) {
        if($('#notify_email').val() == 'enter a valid email address') {
          $('#notify_email').attr('placeholder', '')
          $('#notify_email').val('')
        }
      }
    });
      }
    },

    recentlyViewed: function() {
      var storedProductsMax = 8;
      var storedProductsArray = [];
      var currentProductId = $('#prodid').val();

      if(localStorage.getItem('recentlyViewed') === null) {
        localStorage.setItem('recentlyViewed', '');
      } else {
        storedProductsArray = localStorage.getItem('recentlyViewed').split(',');
      }

      // check if prod id exists on a page
      // check if prod id exists already in the array
      storedProductsArray.unshift(currentProductId);

      // remove if more than max
      storedProductsArray = storedProductsArray.join();
      localStorage.setItem('recentlyViewed', storedProductsArray);

      // console.log('>>>>>>>>>> storedProductsArray', storedProductsArray);
    },

    loadUpsell: function() {
if($('.raffle-product').length == 0) {

      var productIds = localStorage.getItem('recentlyViewed').split(',').map(Number);
      productIds = productIds.filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
      });
      // clean up - remove products existing on the cart
      var cartProductIds = [];
      $('form.cart .cart-item').each(function() {
        cartProductIds.push($(this).data('productid'));
      });
      productIds = productIds.filter(function(el) {
        return cartProductIds.indexOf(el) < 0;
      })

      // console.log('>> upsell arrays', productIds, cartProductIds);

      var dataToSend = {
        'store_name': store,
        'product_ids': productIds,
        'iso_code': Shopify.country,
        // 'location_id': 68178706569
        // 'location_ids': [35407921289, 68178706569]
      }

    if(productIds.length > 0) {
      $.ajax({
        url: 'https://ald-filter.herokuapp.com/api/product_info',
        type: 'POST',
        data: JSON.stringify(dataToSend),
        accept: 'application/json',
        cache: false,
        dataType: 'json',
        contentType: 'application/json',
        success: function(response) {
          // console.log('> product info >', response);
          var counter = 1;
          for(var i in response) {
            if(response[i].product_id !== undefined) {
              if(counter < 9) {
                if(response[i].sold_out != true && response[i].tags.indexOf('RAFFLE_PRODUCT') < 0 && response[i].tags.indexOf('dev-in-store-only') < 0) {
                  // if(response[i].tags.indexOf('a_ss25_drop1') > -1) {

                  // console.log(response[i]);
                  var product = response[i];
                  // TODO should be local_price
                  var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                  // var price = formatPrice(response[i].price, 'USD');
                  var compareAtPrice = price;
                  if(response[i].local_price.compare_at_price !== null) {
                    // TODO should be local_price
                    compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                    // compareAtPrice = formatPrice(response[i].compare_at_price, 'USD');
                  }
                  var priceToDisplay = '';
                  var classCompare = '';

                  priceToDisplay += '<span class="money">'+price+'</span>';
                  if(price != compareAtPrice && response[i].local_price.compare_at_price != 0) {
                    priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                    classCompare = 'plp-product__price--compare';
                  }

                  var images = '';
                  for(var j in response[i].images) {
                    if(j != 0) {
                      if(response[i].images[j].alt != 'dev-product-image-swatch') {
                        images += `                    <div class="swiper-slide upsell-carousel__item">
                          <img src="${response[i].images[j].url}&width=600" alt="" />
                        </div>`
                      }
                    }
                  }
                  var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';
                  
                  var swatchesMobile = '<option value="">Select Color</option>';
                  var swatches = '';
                  var swatchesIds = '';
                  // console.log('upsell', response[i].handles_info)



                  for(var z in response[i].handles_info) {

                    var swatchData = response[i].handles_info[z];
                    // console.log('upsell', swatchData)
                    var swatchHandle = Object.keys(swatchData);
                    var swatchId = Object.values(swatchData);
                    swatchesIds += Object.values(swatchData) + ',';

                    if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                      swatchesIds = jewelrySwatchIds;
                    }

                    var selected = '';
                    var selectedClass = '';
                    if(response[i].product_id == swatchId) {
                      selected = 'selected';
                      selectedClass = 'swatch-colors__item--selected';
                    }

                    swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item upsell-toggle" id="${product.product_id}" new="" data-swatchid="${swatchId}" data-swatchids="${swatchesIds}">
                              <div class="image-square product-image">
                              </div>
                            </a>`

                    var colors = response[i].handles[0];
                    colors = Object.values(colors);
                    colors = colors[0];
                    // console.log('upsell colors', colors);
                    colors = colors.split(',');
                    colors = colors[z];
                    swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                  }

                  if(response[i].handles_info == null) {
                    swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                  }

                  swatchesIds = swatchesIds.slice(0, -1);

/*

*/

                  if(response[i].variants.length == 1) {
                    sizes += '<option value=""></option>';
                    if(response[i].variants[0].sold_out) {
                      sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}" value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    } else {
                      sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    }
                  } else {
                    for(var k in response[i].variants) {
                      sizes += '<option value=""></option>';
                      if(response[i].variants[k].sold_out) {
                        sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      } else {
                        sizes += `<option data-soldout="${response[i].variants[k].sold_out}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      }
                    }
                  }

                  sizes += '</select>';

                  var sizesMobile = '';
                  var showSelectOptions = 'd-none';
                  var showAddToCart = '';
                  var jewelryClass = '';
                  if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                    jewelryClass = 'chain-selector';
                    showSelectOptions = 'd-block';
                    showAddToCart = 'd-none d-lg-block';
                    sizes = $('.chain-select')[0].outerHTML;
                    // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'
                    // console.log('> upsell jewelry sizes', sizes)

                    swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                    swatchesMobile = $('.pendant-select')[0].innerHTML;
                  } 

                  var colorName = response[i].variants[0].color;
                  var customTag = '';

                  if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }

                  $('.recently-viewed').show();

                  $('.recently-viewed-carousel .swiper-wrapper').append(`       <div class="swiper-slide recently-viewed-carousel__item" data-swatchids="${swatchesIds}">
                    <a id="upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" class="product-image image-4-5 upsell-toggle">
                      ${customTag}
                      <img src="${product.images[1].url}&width=600" alt="" />
                    </a>
                    <div class="short-desc plp-product__details">
                      <h3 class="plp-product__title"><a href="#" class="upsell-toggle" id="upsell-${product.product_id}">${product.title}</a></h3>
                      <div class="plp-product__price ${classCompare}">
                        ${priceToDisplay}
                      </div>
                    </div>
                  </div>`);

                  var addToBag = 'Add To Bag';
                  if(product.sold_out) {
                    addToBag = 'Notify Me';
                  }

                  $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                    <button class="close-upsell d-none"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2"/>
                    </svg></button>
                    <div class="upsell-carousel"> 
                      <div class="swiper-wrapper">
                        ${images}
                      </div>
                    </div>

                    <div class="upsell-content product">
                      <h2 class="product__title">${product.title}</h2>
                      <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                      <div class="product__variants product__variants--colors d-none d-lg-block">
                        <div class="product-variants-title d-none d-lg-block">
                          Color: ${colorName}
                        </div>
                        <div class="swatch-colors swiper-container">
                          <div class="swiper-wrapper">
                            ${swatches}
                          </div>
                        </div>
                        <div id="swatch-colors-next" class="swiper-btn-next"></div>
                        <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                      </div>

                      <form class="upsell-form">
                        <div class="random-div d-flex justify-content-between d-lg-block">
                          <div class="product__variants--colors d-lg-none">
                            <div class="custom-select-wrapper">
                              <select class="custom-select">
                                ${swatchesMobile}
                              </select>
                            </div>
                          </div>

                          <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                            <select class="custom-select" disabled>
                              <option val="">One Size</option>
                            </select>
                          </div>

                          <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                              ${sizes}
                          </div>
                        </div>
                        <div class="atc-box">
                          <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                          <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                          <div class="notify">
                              <h4 class="notify__txt">Notify me when this product is in stock </h4>
                              <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                              </div>
                              <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                              <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                              <div class="bis-newsletter-signup">
                                <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                              </div>
                          </div>
                          <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                        </div>
                      </form>
                    </div>
                  </div>`);

                  counter++;
                  // }
                }
              }
            }
          }

          if(counter == 1) {
            $('.section-cart').addClass('no-recently-viewed');
          }

          if($('.upsell-carousel').length) {

          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          console.log('>>>>>>>>>>', isSafari, 'wwi2', window.innerWidth);
          // if(isSafari || getOS() == 'Mac OS') {

          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            console.log('>>>>>>>>>>>>>>', height, imgHeight, width);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }

            var upsellCarousel = new Swiper('.upsell-carousel', {
              spaceBetween: 7,
              slidesPerView: 'auto',
              breakpoints: {
                1025: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  watchOverflow: true,
                }
              },
              on: {
                slideChange: function () {
                  var newIndex = this.activeIndex;
                  if (typeof gtag === 'function') {
                    var sku = $('.cart-upsell-collapse').data('productid');
                    gtag('event', `Cart_Quickview_Image Swipe_${newIndex + 1}_${sku}`);
                  }
                }
              }
            });
          }
          if($('.recently-viewed-carousel .swiper-slide').length > 1) {
            if($('.recently-viewed-carousel').length) {
              var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                spaceBetween: 7,
                slidesPerView: 'auto',
                breakpoints: {
                  1025: {
                    spaceBetween: 14,
                  }
                }
              });
            }
          }

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

          var selectSize = $('.swatch-size .custom-select');
          selectSize.each(function() {
            // if($.length) {
              var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
              $(this).select2({
                placeholder: 'Select Size',
                minimumResultsForSearch: -1,
                dropdownParent: $dropdownParent1,
                dropdownCssClass: "custom-select-dropdown",
                templateResult: function(data, container) {
                  // if(data.element) {
                  //   $(container).addClass($(data.element).attr('class'));
                  // }

                  var tpl = '<span>'+data.text+'</span>';
                  var notifyMe = $(data.element).hasClass('disabled-el');
                  if(notifyMe) {
                    tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                  }
                  return $(tpl);
                }
              }).on('select2:select', function(e) {
                var selectedSize = e.params.data.text;

                if (typeof gtag === 'function') {
                  var sku = $('.cart-upsell-collapse').data('productid');
                  gtag('event', `Cart_Quickview_Select Size_${selectedSize}_${sku}`);
                }
              });
            // }
          })

          $('.cart-upsell-container').on('click', '.select-options', function() {
            console.log('>>> jewelry click');
            $(this).closest('.upsell-form').find('.chain-selector').show().removeClass('d-none');
            $(this).hide().removeClass('d-block');
            $(this).next().show().removeClass('d-none');
            return false;
          });

    $('.cart-upsell-container').on('change', 'select.chain-select', function() {

      // console.log('1', $(this).find(':selected').val(), $(this).find(':selected').data('soldout'), $(this).find(':selected').data('price'));

      var chainPrice = parseFloat($(this).find(':selected').data('original-price'));
      var pendantPrice = parseFloat($(this).closest('.cart-upsell').find('.product__price').data('price'));


      var totalPendantPrice = chainPrice + pendantPrice;
// console.log('totalPPrice', totalPendantPrice, chainPrice);
      // TODO should be local_price
      totalPendantPrice = formatPrice(totalPendantPrice, globalCurrency)
     $(this).closest('.cart-upsell').find('.product__price').text(totalPendantPrice);

     chainId =  $(this).find(':selected').data('prodid');

    });

          $('.swatch-size select, .swatch-size-2 select').on('change', function() {
            $('.select-error').removeClass('select-error');
            $('.size-error').hide();
            $('#show-bis').hide();
            // console.log('upsell select', $(this).find(':selected').hasClass('disabled-el'))
            if($(this).find(':selected').hasClass('disabled-el')) {
              $('.btn-upsell-add').hide();
              $('.notify').show();
              BISHandler();
            } else {
              $('.btn-upsell-add').show();
              $('.notify').hide();
            }

            var variantName = $(this).find(':selected').val();
            // START: scroll to selected variant image
            // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
            // var imageToScroll = undefined;
            // var imageIndexToScroll = undefined;
            // $('.product__container .product__image-item img').each((index,element) => {
            //   if(variantName.includes(element.alt)) {
            //     imageToScroll = element;
            //     imageIndexToScroll = index;
            //   }
            // });

            // if(imageToScroll) {
            //   if(isMobile) {
            //     if(imageIndexToScroll > -1 && productCarousel) {
            //       productCarousel?.forEach((_c) => {
            //         if(_c.size) _c.slideTo(imageIndexToScroll);
            //       });
            //     }
            //   } else {
            //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
            //   }
            // }
            // END: scroll to selected variant image

            // if(!$(this).find(':selected').data('soldout')) {
            //   console.log('1.2')
            //   $('.product__price.money').text('SOLD OUT');

            //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
            //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
            //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
            //     var pendantPr = parseFloat($('#pendant-price').data('price'));
            //     $('.product__price.money').text(chainPr + pendantPr);
            //   } else {
            //     var priceDetails = {
            //       "Price": parseFloat($(this).find(':selected').data('price')),
            //       "Quantity": 1
            //     };

            //     var curEl = $(this);
            //   }
            // } else {
            //   console.log('1.3')
            //   //$('.product__price.money').text($(this).find(':selected').data('price'))
            //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
            //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
            //     var pendantPr = parseFloat($('#pendant-price').data('price'));
            //     $('.product__price.money').text(chainPr + pendantPr);
            //   } else {
            //     var priceDetails = {
            //       "Price": $(this).find(':selected').data('price'),
            //       "Quantity": 1
            //     };

            //     var curEl = $(this);
            //   }
            // }
          });

          // copied from other scripts, to be removed
   // $('.product__variants--colors .custom-select').select2({
   //    placeholder: 'Select Color',
   //    minimumResultsForSearch: -1,
   //    dropdownCssClass: "custom-select-dropdown",
   //    templateResult: function(data, container) {
   //      var img = $(data.element).attr('data-img');
   //      var handle = $(data.element).attr('data-handle');
   //      var tpl = '<a href="'+handle+'"><img src="'+img+'" />'+data.text+'</a>';
   //      return $(tpl);
   //    }
   //  });

          var selectColor = $('.product__variants--colors .custom-select');
          console.log(selectColor, 'color swatcher select2 1')
          selectColor.each(function() {
            // if(selectColor.length) {
              var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
              $(this).select2({
                placeholder: 'Select Color',
                minimumResultsForSearch: -1,
                dropdownParent: $dropdownParent2,
                dropdownCssClass: "custom-select-dropdown",
                templateResult: function(data, container) {
                  var img = $(data.element).attr('data-img');
                  var handle = $(data.element).attr('data-handle');
                  var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                  console.log(img, handle, tpl);
                  return $(tpl);
                },
                templateSelection: function(option) {
                  var swatchid = $(option.element).data('swatchid');
                  var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                  var handle = $(option.element).attr('data-handle');
                  var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                  console.log(img, handle, tpl);
                  return $(tpl);
                }
              });
            // }
          });

           $('.cart-upsell-container').on('change', '.product__variants--colors select', function() {
            var id = $(this).find(':selected').attr('data-swatchid');
            // console.log('upsell mobile select', id, $(this).find('.swatch-colors a[data-swatch-id='+id+']'))
            $(this).closest('.cart-upsell').find('.swatch-colors a[data-swatchid='+id+']').trigger('click');
           });

          $('.recently-viewed-carousel, .cart-upsell-container').on('click', '.upsell-toggle', function() {

            var target = $(this).attr('id');
            var productId = target.split('-')[1];

            if(target.indexOf('upsell') < 0) {
              target = 'upsell-'+target;
            }

            if (typeof gtag === 'function') {
              if($(this).data('swatchid')) {
                // changing color
                var colorName = $(`.product__variants--colors option[data-swatchid="${$(this).data('swatchid')}"]`).first().text();
                var productId = $('.cart-upsell-collapse').data('productid');
                gtag('event', `Cart_Quickview_${colorName}_${productId}`);
              } else {
                // clicking recommendated product
                var clickedIndex = $(this).closest('.swiper-wrapper')
                  .find('.recently-viewed-carousel__item')
                  .index($(this).parents('.recently-viewed-carousel__item'));
                gtag('event', `Cart_Product Recommendation_${clickedIndex + 1}_${productId}`);
              }
            }

            // console.log('>>> target',  target)
            $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
// console.log('remove class')
            $('#popup-'+target).addClass('cart-upsell-collapse');
            $('.cart-upsell-container').addClass('cart-upsell-container--visible');
            $('.cart-upsell-overlay').addClass('cart-upsell-overlay--visible');
            $('body').addClass('cart-upsell--visible');
            var swatches = $(this).closest('.recently-viewed-carousel__item').data('swatchids');
// console.log('>>> sx', swatches)
            if(swatches === undefined) {
              swatches = $(this).closest('.cart-upsell').data('swatchids');
              // swatches = swatches.slice(0, -1);
            }
// console.log('>>> s', swatches)
            var dataToSend = {
              'store_name': store,
              'product_ids': swatches.split(',').map(Number),
              'iso_code': Shopify.country,
              // 'location_ids': [35407921289, 68178706569]
            }
// console.log('1')
            $.ajax({
              url: 'https://ald-filter.herokuapp.com/api/product_info',
              type: 'POST',
              data: JSON.stringify(dataToSend),
              accept: 'application/json',
              cache: false,
              dataType: 'json',
              contentType: 'application/json',
              success: function(response) {
                // console.log('upsell swatch', response);
// console.log('2')
                for(var i in response) {
                  var img = response[i].image_url;
                  for(var j in response[i].images) {
                    if(response[i].images[j].alt == 'dev-product-image-swatch') {
                      img = response[i].images[j].url;
                    }
                  }

                  $('.swatch-colors__item[data-swatchid="'+response[i].product_id+'"] .product-image').append(`<img src="${img}&width=100">`);
                  $('option[data-swatchid="'+response[i].product_id+'"]').data('img', img+'&width=100');
                  // console.log('option[data-swatchid="'+response[i].product_id+'"]', img+'&width=100')
// console.log('3')
                  // console.log(response[i]);
                  var product = response[i];
                  // TODO should be local_price
                  var price = formatPrice(response[i].local_price.price, response[i].local_price.currency);
                  // var price = formatPrice(response[i].price, 'USD');

                  var compareAtPrice = price;
                  if(response[i].local_price.compare_at_price !== null) {
                    // TODO should be local_price
                    compareAtPrice = formatPrice(response[i].local_price.compare_at_price, response[i].local_price.currency);
                    // compareAtPrice = formatPrice(response[i].compare_at_price, 'USD');
                  }
                  var priceToDisplay = '';
                  var classCompare = '';

                  priceToDisplay += '<span class="money">'+price+'</span>';
                  if(price != compareAtPrice) {
                    priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
                    classCompare = 'plp-product__price--compare';
                  }

                  var images = '';
                  for(var j in response[i].images) {
                    if(j != 0) {
                      if(response[i].images[j].alt != 'dev-product-image-swatch') {
                        images += `<div class="swiper-slide upsell-carousel__item">
                              <img src="${response[i].images[j].url}&width=600" alt="" />
                            </div>`
                      }
                    }
                  }
                  var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';

                  var swatches = '';
                  var swatchesMobile = '<option value="">Select Color</option>';
                  var swatchesIds = '';
                  // console.log('upsell', response[i].handles_info)
                  for(var z in response[i].handles_info) {
                    var swatchData = response[i].handles_info[z];
                    // console.log('upsell', swatchData)
                    var swatchHandle = Object.keys(swatchData);
                    var swatchId = Object.values(swatchData);
                    swatchesIds += Object.values(swatchData) + ',';

                    var selected = '';
                    var selectedClass = '';
                    if(response[i].product_id == swatchId) {
                      selected = 'selected';
                      selectedClass = 'swatch-colors__item--selected';
                    }

                    swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item " new="" data-swatchid="${swatchId}"  data-swatchids="${swatchesIds}">
                              <div class="image-square product-image">
                              </div>
                            </a>`

                    var colors = response[i].handles[0];
                    colors = Object.values(colors);
                    colors = colors[0];
                    // console.log('upsell colors', colors);
                    colors = colors.split(',');
                    colors = colors[z];
                    swatchesMobile += `<option ${selected} data-img="" data-handle="" data-swatchid="${swatchId}">${colors}</option>`
                  }

                  if(response[i].handles_info == null) {
                    swatchesMobile = `<option selected data-img="${response[i].image_url}&width=100" data-handle="" data-swatchid="">${response[i].variants[0].color}</option>`;
                  }

                  // console.log('4')
                  swatchesIds = swatchesIds.slice(0, -1);

/*

*/

                  if(response[i].variants.length == 1) {
                    sizes += '<option value=""></option>';
                    if(response[i].variants[0].sold_out) {
                      sizes += `<option class="disabled-el" data-soldout="${response[i].variants[0].sold_out}" value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    } else {
                      sizes += `<option data-soldout="${response[i].variants[0].sold_out}" selected value="${response[i].variants[0].id}">${response[i].variants[0].size}</option>`;
                    }
                  } else {
                    for(var k in response[i].variants) {
                      sizes += '<option value=""></option>';
                      if(response[i].variants[k].sold_out) {
                        sizes += `<option class="disabled-el" data-soldout="${response[i].variants[k].sold_out}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      } else {
                        sizes += `<option data-soldout="${response[i].variants[k].sold_out}" value="${response[i].variants[k].id}">${response[i].variants[k].size}</option>`;
                      }
                    }
                  }
                  sizes += '</select>';

                  // if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                  //   sizes = $('.chain-select')[0].outerHTML;
                  //   // console.log('> upsell jewelry sizes', sizes)

                  //   swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                  //   swatchesMobile = $('.pendant-select')[0].innerHTML;
                  // } 

                  var sizesMobile = '';
                  var showSelectOptions = 'd-none';
                  var showAddToCart = '';
                  var jewelryClass = '';
                  if(response[i].tags.indexOf('dev-jewelry-main') > -1) {
                    jewelryClass = 'chain-selector';
                    showSelectOptions = 'd-block';
                    showAddToCart = 'd-none d-lg-block';
                    sizes = $('.chain-select')[0].outerHTML;
                    // sizes = '<select class="custom-select" disabled><option>One Size</option></select>'
                    // console.log('> upsell jewelry sizes', sizes)

                    swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

                    swatchesMobile = $('.pendant-select')[0].innerHTML;
                  } 

                  var colorName = response[i].variants[0].color;
                  var customTag = '';

                  if(response[i].tags.indexOf('PREORDER_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">Reserve</div>';
                  }
                  if(response[i].tags.indexOf('NEW_PRODUCT') > -1) {
                    customTag = '<div class="plp-product__tag">NEW</div>  ';
                  }

// console.log('5')
                  if(!$('#popup-upsell-'+product.product_id).length) {

                    var addToBag = 'Add To Bag';
                    if(product.sold_out) {
                      addToBag = 'Notify Me';
                    }

                    $('.cart-upsell-container').append(`<div class="cart-upsell" data-productid="${product.product_id}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-swatchids="${swatchesIds}">
                      <button class="close-upsell d-none"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2"/>
                      </svg></button>
                      <div class="upsell-carousel"> 
                        <div class="swiper-wrapper">
                          ${images}
                        </div>
                      </div>

                      <div class="upsell-content product">
                        <h2 class="product__title">${product.title}</h2>
                        <div class="product__price  ${classCompare}" data-price="${response[i].local_price.price}">${priceToDisplay}</div>
                        <div class="product__variants product__variants--colors d-none d-lg-block">
                          <div class="product-variants-title d-none d-lg-block">
                            Color: ${colorName}
                          </div>
                          <div class="swatch-colors swiper-container">
                            <div class="swiper-wrapper">
                              ${swatches}
                            </div>
                          </div>
                          <div id="swatch-colors-next" class="swiper-btn-next"></div>
                          <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
                        </div>

                      <form class="upsell-form">
                        <div class="random-div d-flex justify-content-between d-lg-block">
                          <div class="product__variants--colors d-lg-none">
                            <div class="custom-select-wrapper">
                              <select class="custom-select">
                                ${swatchesMobile}
                              </select>
                            </div>
                          </div>

                          <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                            <select class="custom-select" disabled>
                              <option val="">One Size</option>
                            </select>
                          </div>

                          <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                              ${sizes}
                          </div>
                        </div>
                        <div class="atc-box">
                          <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
                          <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add">${addToBag}</button>
                          <div class="notify">
                              <h4 class="notify__txt">Notify me when this product is in stock </h4>
                              <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                                <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                              </div>
                              <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                              <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                              <div class="bis-newsletter-signup">
                                <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                                <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                              </div>
                          </div>
                          <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn">FULL DETAILS</a>
                        </div>
                      </form>
                      </div>
                    </div>`);
                  }
                }

          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          console.log('>>>>>>>>>>', isSafari, 'wwi3', window.innerWidth);
          // if(isSafari || getOS() == 'Mac OS') {
          if(window.innerWidth > 1024) {
            var height = window.innerHeight;
            var imgHeight = height - 340;
            var width = Math.floor((4 * imgHeight) / 5);
            console.log('>>>>>>>>>>>>>>', height, imgHeight, width);
            $('.upsell-carousel, .cart-upsell').width(width);
            if(width > 493) {
              $('.upsell-carousel img').width('100%');
            } else {
              $('.upsell-carousel img').width('');
            }
          } else {
            $('.upsell-carousel, .cart-upsell').width('');
          }
          
                if($('.upsell-carousel').length) {
                  var upsellCarousel = new Swiper('.upsell-carousel', {
                    spaceBetween: 7,
                    slidesPerView: 'auto',
                    breakpoints: {
                      1025: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        watchOverflow: true,
                      }
                    }
                  });
                }

                if($('.recently-viewed-carousel .swiper-slide').length > 1) {
                  if($('.recently-viewed-carousel').length) {
                    var upsellCarousel = new Swiper('.recently-viewed-carousel', {
                      spaceBetween: 7,
                      slidesPerView: 'auto',
                      breakpoints: {
                        1025: {
                          spaceBetween: 14,
                        }
                      }
                    });
                  }
                }

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

                var selectSize = $('.swatch-size .custom-select');
                selectSize.each(function() {
                  // if($.length) {
                    var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Size',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent1,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {
                        // if(data.element) {
                        //   $(container).addClass($(data.element).attr('class'));
                        // }

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).hasClass('disabled-el');
                        if(notifyMe) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        }
                        return $(tpl);
                      }
                    });
                  // }
                })

                var selectSize2 = $('.swatch-size .chain-select');
                selectSize2.each(function() {
                  // if($.length) {
                    var $dropdownParent1 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Size',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent1,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {

                        var tpl = '<span>'+data.text+'</span>';
                        var notifyMe = $(data.element).data('price');
                        notifyMe = notifyMe + '';
                        // notifyMe = notifyMe.replace('.00', '');
                        if(parseInt(notifyMe) != 0) {
                          tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">+ '+notifyMe+'</span></span>';  
                        }
                        // if(data.element) {
                        //   $(container).addClass($(data.element).attr('class'));
                        // }

                        // var tpl = '<span>'+data.text+'</span>';
                        // var notifyMe = $(data.element).hasClass('disabled-el');
                        // if(notifyMe) {
                        //   tpl = '<span class="notify-me-item-wrapper">'+data.text+'<span class="notify-me-mobile">Notify Me</span></span>';
                        // }
                        return $(tpl);
                      }
                    });
                  // }
                })

                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }

                $('.swatch-size select, .swatch-size-2 select').on('change', function() {
                  $('.select-error').removeClass('select-error');
                  $('.size-error').hide();
                  $('#show-bis').hide();
                  // console.log('upsell select', $(this).find(':selected').hasClass('disabled-el'))
                  if($(this).find(':selected').hasClass('disabled-el')) {
                    $('.btn-upsell-add').hide();
                    $('.notify').show();
                  } else {
                    $('.btn-upsell-add').show();
                    $('.notify').hide();
                  }

                  // console.log('BIS Handler', $(this).val())

                  BISHandler($(this).val());

                  var variantName = $(this).find(':selected').val();
                  // START: scroll to selected variant image
                  // var isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
                  // var imageToScroll = undefined;
                  // var imageIndexToScroll = undefined;
                  // $('.product__container .product__image-item img').each((index,element) => {
                  //   if(variantName.includes(element.alt)) {
                  //     imageToScroll = element;
                  //     imageIndexToScroll = index;
                  //   }
                  // });

                  // if(imageToScroll) {
                  //   if(isMobile) {
                  //     if(imageIndexToScroll > -1 && productCarousel) {
                  //       productCarousel?.forEach((_c) => {
                  //         if(_c.size) _c.slideTo(imageIndexToScroll);
                  //       });
                  //     }
                  //   } else {
                  //     $('html, body').animate({ scrollTop: imageToScroll.getBoundingClientRect().top + document.documentElement.scrollTop - 80}, 1000);
                  //   }
                  // }
                  // END: scroll to selected variant image

                  // if(!$(this).find(':selected').data('soldout')) {
                  //   console.log('1.2')
                  //   $('.product__price.money').text('SOLD OUT');

                  //   console.log('>>> ', $(this).find(':selected').data('price'), $('#pendant-price').data('price'));
                  //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                  //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                  //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                  //     $('.product__price.money').text(chainPr + pendantPr);
                  //   } else {
                  //     var priceDetails = {
                  //       "Price": parseFloat($(this).find(':selected').data('price')),
                  //       "Quantity": 1
                  //     };

                  //     var curEl = $(this);
                  //   }
                  // } else {
                  //   console.log('1.3')
                  //   //$('.product__price.money').text($(this).find(':selected').data('price'))
                  //   if(globalEsetcurrency === 'USD' && globalEsetcountry === 'US') {
                  //     var chainPr = parseFloat($(this).find(':selected').data('original-price'));
                  //     var pendantPr = parseFloat($('#pendant-price').data('price'));
                  //     $('.product__price.money').text(chainPr + pendantPr);
                  //   } else {
                  //     var priceDetails = {
                  //       "Price": $(this).find(':selected').data('price'),
                  //       "Quantity": 1
                  //     };

                  //     var curEl = $(this);
                  //   }
                  // }
                });

                var selectColor = $('.product__variants--colors .custom-select');

                console.log(selectColor, 'color swatcher select2 2')
                selectColor.each(function() {
                  // if(selectColor.length) {
                    var $dropdownParent2 = $(this).closest('.custom-select-wrapper');
                    $(this).select2({
                      placeholder: 'Select Color',
                      minimumResultsForSearch: -1,
                      dropdownParent: $dropdownParent2,
                      dropdownCssClass: "custom-select-dropdown",
                      templateResult: function(data, container) {
                        var swatchid = $(data.element).data('swatchid');
                        var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                        var handle = $(data.element).attr('data-handle');
                        var tpl = '<span><img src="'+img+'" />'+data.text+'</span>';
                        console.log(img, handle, tpl);
                        return $(tpl);
                      },
                      templateSelection: function(option) {
                        var swatchid = $(option.element).data('swatchid');
                        var img = $('option[data-swatchid="'+swatchid+'"]').data('img');
                        var handle = $(option.element).attr('data-handle');
                        var tpl = '<span><img src="'+img+'" />'+option.text+'</span>';
                        console.log(img, handle, tpl);
                        return $(tpl);
                      }
                    });
                  // }
                });

              }
            });

            return false
          });

          $('.cart-upsell-container').on('click', '.swatch-colors__item', function() {
            var target = $(this).data('swatchid');
            $(this).find('.close-upsell').trigger('click');
            // $('#popup-upsell-'+id)

            // var target = $(this).attr('id');

            // console.log('>>>',  target, '#popup-upsell-'+target)

            $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
            $('#popup-upsell-'+target).addClass('cart-upsell-collapse');
            $('.cart-upsell-container').addClass('cart-upsell-container--visible');
            $('.cart-upsell-overlay').addClass('cart-upsell-overlay--visible');
            $('body').addClass('cart-upsell--visible');

            // setTimeout(function() {
                if($('.swatch-colors').length > 0) {
                  var productCarouselColors = new Swiper('.swatch-colors', {
                    // spaceBetween: 1,
                    slidesPerView: 'auto',
                    navigation: {
                      nextEl: '#swatch-colors-next',
                      prevEl: '#swatch-colors-prev',
                    },
                  });
                }
            // }, 2000)

            return false;
          });

          $('.btn-upsell-add').on('click', function() {
            var sku = $('.cart-upsell-collapse').data('productid');
            if (typeof gtag === 'function' && sku) {
              gtag('event', `Cart_Quickview_Add to Bag_${sku}`);
            }
          });

          $('.upsell-full-details-btn').on('click', function() {
            var sku = $('.cart-upsell-collapse').data('productid');
            if (typeof gtag === 'function' && sku) {
              gtag('event', `Cart_Quickview_Full Details_${sku}`);
            }
          });
        }
      });
    } else {
      $('.section-cart').addClass('no-recently-viewed');
    }
      }
    }
  }

  $(function () {
    aldscripts.init();
  });

})(jQuery);

    function BISCallback(data){
      var msg = '';
      var success = true;
      if (data.status == 'OK') {
        //msg = 'Thank you. You will be sent an email when this product is in stock again';
        //$('.bismessage').text(msg);
        $('.notify-success-message').show();
        $('.notify h4, .notify input').hide();

        $('.bis-newsletter-signup').hide();
      } else {
        for (var k in data.errors) {
          msg += data.errors[k].join();
        }
        // console.log(msg);
        if(msg === 'You have already registered for a notification for that item.') {
          $('.notify__txt').addClass('atc-error').text('You have already registered for a notification.').show();
        } else {
          $('.notify__txt').addClass('atc-error').text('Please enter a valid email address').show();
        }
        $('#notify_email').addClass('atc-error');
        $('.notify__txt').addClass('bis-error');
        success = false;
        // $('.notify-success-message').text(msg).show();
        // $('.notify h4, .notify input').hide();
        // console.log(msg);
      }
      if(success) {
        setTimeout(function() {
          $('.notify h4').text('Notify me when this product is in stock').removeClass('atc-error');
          $('.notify h4, .notify input, #notify').show();
          $('.notify input[type="email"]').val('');
          $('.notify-success-message').hide();
          $('#add-submit').show();

          $(".swatch-size .custom-select").val('').trigger('change')
          $('#show-bis').show();
          $('.notify').hide();
          // $('#notify_email').attr('disabled', true);
          $('.swatch-size__item input:checked').prop('checked', false);


          // console.log(biseml)



          $('#k_id_email_product').val(biseml);
          $('#email_signup_product').trigger('submit');
        }, 4000);
      }
    }

        function BISHandler(id) {

      $('.cart-upsell-container').on('click', '#notify', function(e){
        e.preventDefault();

        $notify = $('.cart-upsell-collapse');

        // console.log('>> bis 2', variantId)
        var variantId = $notify.find('.swatch-size select').val();
        var email = $notify.find('#notify_email').val();
        var productId = $(this).closest('.cart-upsell').data('productid');
        // biseml = $notify.find('#notify_email').val();

        // console.log('>> bis', variantId)
        if(variantId === '') {
          //$('.size-error').show();

          $notify.find('.swatch-size').addClass('select-error');

        } else {
          if ( email == "" || email.indexOf('@') == -1 ) {
            $notify.find('.notify__txt').addClass('atc-error').text('Please enter a valid email address').show();
            $notify.find('#notify_email').addClass('atc-error');
            if($(window).width() < 1025) {
              $notify.find('#notify_email').val('enter a valid email address')
            }
          } else {
            // $('.notify__txt').css('visibility', 'hidden').hide();
            $notify.find('.notify__txt').hide();
            $notify.find('#notify_email').removeClass('atc-error');
            // console.log('bispopover', BIS.Popover)
            // BIS.createPopover(email, variantId);
            BIS.create(email, variantId, productId);
        $notify.find('.notify-success-message').show();
        $notify.find('.notify h4, .notify input').hide();

        $notify.find('.bis-newsletter-signup').hide();

        setTimeout(function() {
          // $('.notify h4').text('Notify me when this product is in stock').removeClass('atc-error');
          $notify.find('.notify input, #notify').show();
          $notify.find('.notify input[type="email"]').val('');
          $notify.find('.notify-success-message').hide();
          $notify.find('#add-submit').show();

          $notify.find(".swatch-size .custom-select").val('').trigger('change')
          // $('#show-bis').show();
          $notify.find('.notify').hide();
          // $('#notify_email').attr('disabled', true);
          $notify.find('.swatch-size__item input:checked').prop('checked', false);

            $('.cart-upsell-collapse').find('.close-upsell').trigger('click');
            // $('#popup-upsell-'+id)

            // var target = $(this).attr('id');

            // console.log('>>>',  target, '#popup-upsell-'+target)

            // $('.cart-upsell-collapse').removeClass('cart-upsell-collapse')
          // console.log(biseml)



          // $('#k_id_email_product').val(biseml);
          // $('#email_signup_product').trigger('submit');
        }, 4000);
          }
        }

      })
    }
let os = "unknown";
function getOS() {
  const userAgent = window.navigator.userAgent;
  const platform =
    window.navigator?.userAgentData?.platform || window.navigator.platform;
    console.log('>>>', platform);
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K", "macOS"];
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}
